import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api_url } from '../constants/data';


function ViewReports() {
    const navigate = useNavigate();
    const [reports, setReports] = useState([])
    const token = localStorage.getItem('auth_token')
    
    useEffect(() => {
        axios.post(`${api_url}/reports`, {}, {headers: { 'Authorization': 'Bearer ' + token}}).then(res => {
            const data = []
            res.data.map(x => {
                const jsonData = JSON.parse(x.report_json)
                data.push({
                    id: x.id,
                    title: 'Report',
                    time: x.created_at.replace('T', ' ').substring(0, 16),
                    type: x.type,
                    file: x.report_files,
                    abuseLocation: jsonData.where_happend,
                    abuseDate: jsonData.when_happend,
                    awarenessDate: jsonData.when_happend,
                    randomOption: jsonData.where_happend,
                    awarenessOption: jsonData.where_happend,
                    personName: jsonData.fullname,
                    personFunction: jsonData.function,
                    personOrganization: jsonData.department,
                    abuseDescription: jsonData.description,
                })
            })

            setReports([...data])
        }).catch(err => {
            console.error(err.response.data.error)
        })
    }, [])

    const reportss = [
        {
            id: 0,
            title: 'Report',
            time: "15:30PM",
            type: "Doping",
            abuseLocation: 'borjomi',
            abuseDate: '12/04/2023',
            awarenessDate: '14/05/2023',
            randomOption: ' option',
            awarenessOption: 'option2',
            personName: 'Giorgi Barbariani',
            personFunction: 'Runner',
            personOrganization: 'Runnets Academy',
            abuseDescription: ' Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s',
        },
        {
            id: 1,
            title: 'Report',
            time: "15:30PM",
            type: "Alcohol",
            abuseLocation: 'borjomi',
            abuseDate: '12/04/2023',
            awarenessDate: '14/05/2023',
            randomOption: ' option',
            awarenessOption: 'option2',
            personName: 'James',
            personFunction: 'Runner',
            personOrganization: 'Runnets Academy',
            abuseDescription: ' Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s',
        },
        {
            id: 2,
            title: 'Report',
            time: "15:30PM",
            type: "Installation",
            abuseLocation: 'borjomi',
            abuseDate: '12/04/2023',
            awarenessDate: '14/05/2023',
            randomOption: ' option',
            awarenessOption: 'option2',
            personName: 'James',
            personFunction: 'Runner',
            personOrganization: 'Runnets Academy',
            abuseDescription: ' Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s',
        },
        {
            id: 3,
            title: 'Report',
            time: "15:30PM",
            type: "Integrity",
            abuseLocation: 'borjomi',
            abuseDate: '12/04/2023',
            awarenessDate: '14/05/2023',
            randomOption: ' option',
            awarenessOption: 'option2',
            personName: 'James',
            personFunction: 'Runner',
            personOrganization: 'Runnets Academy',
            abuseDescription: ' Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s',
        },
        {
            id: 4,
            title: 'Report',
            time: "15:30PM",
            type: "Other",
            abuseLocation: 'borjomi',
            abuseDate: '12/04/2023',
            awarenessDate: '14/05/2023',
            randomOption: ' option',
            awarenessOption: 'option2',
            personName: 'James',
            personFunction: 'Runner',
            personOrganization: 'Runnets Academy',
            abuseDescription: ' Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s',
        },
        {
            id: 5,
            title: 'Report',
            time: "15:30PM",
            type: "Alcohol",
            abuseLocation: 'borjomi',
            abuseDate: '12/04/2023',
            awarenessDate: '14/05/2023',
            randomOption: ' option',
            awarenessOption: 'option2',
            personName: 'James',
            personFunction: 'Runner',
            personOrganization: 'Runnets Academy',
            abuseDescription: ' Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s',
        },
        {
            id: 6,
            title: 'Report',
            time: "15:30PM",
            type: "Doping",
            abuseLocation: 'Bakuriani',
            abuseDate: '12/04/2023',
            awarenessDate: '14/05/2023',
            randomOption: ' option 1',
            awarenessOption: 'option2',
            personName: 'James  Atkinson',
            personFunction: 'Runner',
            personOrganization: 'Runnets Academy',
            abuseDescription: ' Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s',
        },
    ]
    const handleViewReportsClick = (report) => {
        navigate('/ReportInner', { state: { report} }); // Pass both report and index
      };
    
    return (
        <div className='viewreports'>
            <h1>Your Reports List</h1>
            <div className="reports-header">
                <h4>Report</h4>
                <h4>Time</h4>
                <h4>Type</h4>
                <h4>File</h4>
                <h4>location</h4>
                <h4>Abuse date</h4>
                <h4>Awareness date</h4>
                <h4>Period 1</h4>
                <h4>Period 2</h4>
                <h4>Name</h4>
                <h4>Person Function</h4>
            </div>
            <div className="viewreports-inner">
                {
                    reports.map((reportdata) => (
                        <div className='reportitem' key={reportdata.id}>
                            <h4>{reportdata.title + '#' + reportdata.id}</h4>
                            <p>{reportdata.time}</p>
                            <p>{reportdata.type}</p>
                            <p><a href={reportdata.file} target='_blank' download='download'>Download File</a></p>
                            <p>{reportdata.abuseLocation}</p>
                            <p>{reportdata.abuseDate}</p>
                            <p>{reportdata.awarenessDate}</p>
                            <p>{reportdata.awarenessOption}</p>
                            <p>{reportdata.randomOption}</p>
                            <p>{reportdata.personName}</p>
                            <p>{reportdata.personFunction}</p>
                            <button onClick={() => handleViewReportsClick(reportdata)}>View Report</button>
                        </div>
                    ))
                }


            </div>
        </div>
    )
}

export default ViewReports